import isEmpty from 'lodash/isEmpty';
import i18n from '../../../../../language/i18n';

export default function(baseComponentProps) {
  return {
    props: {
      ...baseComponentProps,
      chips: { type: Boolean, default: true },
      multiple: { type: Boolean, default: true },
      clearable: { type: Boolean, default: true },
      deletableChips: { type: Boolean, default: true },
      filled: { type: Boolean, default: true },
      smallChips: { type: Boolean, default: true },
      filterOptions: { type: Array, required: false },
      filterOptionValue: { type: String, default: undefined },
      optionSearchKey: { type: String },
      optionSelectDisabled: { type: Boolean, default: false },
      clearIcon: { type: String, default: '$wClose' },
    },
    computed: {
      filterHasFilterOptions() {
        return isEmpty(this.filterOptions) === false;
      },
      filterOptionText() {
        const currentFilterOption = this.filterOptions?.find((_option) => _option.value === this.filterOptionValue);
        return currentFilterOption?.text ?? i18n.t('Common.select');
      }
    },
    methods: {
      handleFilterOption(option) {
        this.$emit('input', {
          preventDefault: true,
          searchKeyOverride: this.optionSearchKey,
          value: option.value
        });
      }
    },
    watch: {
      filterOptions: {
        handler() {
          if (this.filterOptions == undefined) { return }

          if (this.filterOptionValue == undefined) {
            window.console.error(`"filterOptionValue" is required`);
          }

          if (this.optionSearchKey == undefined) {
            window.console.error(`"optionSearchKey" is required`);
          }
        },
        immediate: true
      },
    }
  }
}
